import { render, staticRenderFns } from "./VCommissioning.vue?vue&type=template&id=945f8baa"
import script from "./VCommissioning.vue?vue&type=script&lang=js"
export * from "./VCommissioning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports